import React from "react";
import { Paper, Typography } from "@mui/material";
import { festiveCardSx, colors } from "./constants";

export function StatusCard({ icon, title, children }) {
  return (
    <Paper
      elevation={0}
      sx={{
        ...festiveCardSx,
        maxWidth: 420,
        width: "100%",
        p: { xs: 3, sm: 4 },
        textAlign: "center",
        zIndex: 2,
      }}
    >
      {icon}
      <Typography
        variant="h5"
        fontWeight={800}
        gutterBottom
        sx={{ color: colors.ivory }}
      >
        {title}
      </Typography>
      {children}
    </Paper>
  );
}
